import {
  Button,
  TextField,
  InputAdornment,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
} from "@mui/material";
import { useEffect, useState } from "react";
import { MdClose, MdSearch, MdVisibility } from "react-icons/md";
import { getImportedData, getImportedHistoryFileData } from "../../../Api";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";

// Constants for file types
const File_Types = [
  { id: 1, value: "OFAC_SDN", label: "OFAC" },
  { id: 2, value: "OFAC_NON_SDN", label: "OFAC NON-SDN" },
  { id: 3, value: "UK_Sanctions", label: "UK Sanctions" },
  { id: 4, value: "PEP", label: "PEP" },
  { id: 5, value: "WATCH_LIST", label: "Watch List" },
  { id: 6, value: "GREY_LIST", label: "Grey List" },
  { id: 7, value: "WHITE_LIST", label: "White List" },
  { id: 8, value: "PC-LFM", label: "PC-LFM" },
  { id: 9, value: "NC", label: "NC" },
];
const ViewFilesModal = ({
  viewFilesModal,
  setViewFilesModal,
  // onFirstPage,
  // onLastPage,
  // onPrevPage,
  // onNextPage,
}) => {
  const navigate = useNavigate();
  const [selectedFileType, setSelectedFileType] = useState(null);
  const [modalSelectedFile, setModalSelectedFile] = useState(null);
  const [modalSearchTerm, setModalSearchTerm] = useState("");

  const [loading, setLoading] = useState(false);
  const [modalData, setModalData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: 2,
    totalPages: 1,
    totalCount: 0,
  });
  const [showPreviewTable, setShowPreviewTable] = useState(false);
  const [detailsPagination, setDetailsPagination] = useState({
    currentPage: 1,
    pageSize: 5,
    totalPages: 1,
    totalCount: 0,
  });

  const onFirstPage = () => {
    setPagination((prev) => ({ ...prev, currentPage: 1 }));
  };
  const onLastPage = () => {
    setPagination((prev) => ({ ...prev, currentPage: prev.totalPages }));
  };
  const onPrevPage = () => {
    setPagination((prev) => {
      const newPage = Math.max(prev.currentPage - 1, 1);
      return { ...prev, currentPage: newPage };
    });
  };
  const onNextPage = () => {
    setPagination((prev) => {
      const newPage = Math.min(prev.currentPage + 1, prev.totalPages);
      return { ...prev, currentPage: newPage };
    });
  };

  const getTableHeaders = () => {
    const fileType = selectedFileType?.value;

    // Special handling for Address tab files
    if (fileType === "OFAC_SDN" || fileType === "OFAC_NON_SDN") {
      return [
        { key: "index", label: "#" },
        { key: "ENT_NUM", label: "ENT_NUM" },
        { key: "SDN_NAME", label: "SDN Name" },
        { key: "SDN_TYPE", label: "SDN Type" },
        { key: "PROGRAM", label: "Program" },
        { key: "TITLE", label: "Title" },
        { key: "CALL_SIGN", label: "Call Sign" },
        { key: "VESSEL_TYPE", label: "Vessel Type" },
        { key: "TONNAGE", label: "Tonnage" },
        { key: "GRT", label: "GRT" },
        { key: "VESSEL_FLAG", label: "Vessel Flag" },
        { key: "VESSEL_OWNER", label: "Vessel Owner" },
        // { key: "REMARKS", label: "Remarks" }
      ];
    } else if (fileType === "UK_Sanctions") {
      return [
        { key: "index", label: "#" },
        { key: "UNIQUE_ID", label: "Unique ID" },
        { key: "OFSI_GROUP_ID", label: "OFSI Group ID" },
        { key: "NAME", label: "Name" },
        { key: "REGIME_NAME", label: "Regime Name" },
        { key: "TYPE", label: "Type" },
        { key: "DESIGNATION_SOURCE", label: "Designation Source" },
        { key: "DATE_DESIGNATED", label: "Date Designated" },
        { key: "SANCTIONS_IMPOSED", label: "Sanctions Imposed" },
      ];
    } else {
      return [
        { key: "index", label: "#" },
        { key: "NAME", label: "Name" },
        { key: "FILE_TYPE", label: "File Type" },
        { key: "LOAD_DATE", label: "Load Date" },
        { key: "LOAD_TIME", label: "Load Time" },
      ];
    }
  };

  const fetchHistoryData = async (page = 1) => {
    try {
      setShowPreviewTable(false);
      setModalSelectedFile([]);
      if (!selectedFileType) {
        setTableData([]);
        return;
      }
      setLoading(true);
      // Swal.fire({
      //   html: `<img src=${require("../../../assets/loader.gif")} style="width: 50px" alt="loader">`,
      //   showConfirmButton: false,
      //   heightAuto: false,
      //   customClass: { popup: "loader-swal" },
      //   allowOutsideClick: false,
      // });

      const response = await getImportedHistoryFileData({
        file_type: selectedFileType?.value,
        bank_code: localStorage.getItem("bank_code") || "",
        page: page,
        pageSize: pagination?.pageSize || 2,
      });

      Swal.close();

      if (response?.status === "S") {
        const files =
          response?.result_info?.length > 0
            ? response.result_info.map((file) => ({
                id: `${file.file_name}_${file.load_date}_${file.load_time}`,
                file_name: file.file_name,
                fileType: selectedFileType?.value,
                loadDate: file.load_date,
                loadTime: file.load_time,
                bankCode: file.bank_code,
              }))
            : [];

        setTableData(files);

        // Update pagination from response
        if (response.pagination) {
          setPagination((prev) => ({
            ...prev,
            currentPage: response.pagination.currentPage || 1,
            totalPages: response.pagination.totalPages || 1,
            totalCount: response.pagination.totalCount || 0,
          }));
        }
      } else if (
        response?.status === "F" &&
        response?.message === "Unauthorized - Missing token"
      ) {
        Swal.fire({
          text: "Please login with your credentials",
          icon: "warning",
          showConfirmButton: false,
          timer: 3000,
        }).then(() => {
          localStorage.clear();
          navigate("/login");
        });
      } else {
        Swal.fire({
          icon: "warning",
          text: response?.message || "Failed to fetch data",
          showConfirmButton: false,
          timer: 3000,
        });
        setTableData([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      Swal.fire({
        icon: "error",
        text: error.message || "Something went wrong",
        showConfirmButton: false,
        timer: 3000,
      });
      setTableData([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchPreviewData = async (file, page = 1) => {
    if (!file?.file_name) {
      console.error("No file data provided");
      return;
    }

    setLoading(true);
    setShowPreviewTable(true);
    try {
      Swal.fire({
        html: `<img src=${require("../../../assets/loader.gif")} style="width: 50px" alt="loader">`,
        showConfirmButton: false,
        heightAuto: false,
        customClass: { popup: "loader-swal" },
        allowOutsideClick: false,
      });

      const selectedFileType = file.fileType;
      const response = await getImportedData({
        file_type: selectedFileType,
        file_name: file.file_name,
        bank_code: localStorage.getItem("bank_code") || "",
        page: page,
        pageSize: detailsPagination.pageSize,
      });

      Swal.close();

      if (response?.status === "S") {
        setModalData(response.result_info || []);
        if (response.pagination) {
          setDetailsPagination((prev) => ({
            ...prev,
            currentPage: response.pagination.currentPage || 1,
            totalPages: response.pagination.totalPages || 1,
            totalCount: response.pagination.totalCount || 0,
          }));
        }
      } else if (
        response?.status === "F" &&
        response?.message === "Unauthorized - Missing token"
      ) {
        Swal.fire({
          text: "Please login with your credentials",
          icon: "warning",
          showConfirmButton: false,
          timer: 3000,
        }).then(() => {
          localStorage.clear();
          navigate("/login");
        });
      } else {
        Swal.fire({
          icon: "warning",
          text: response?.message || "Failed to fetch preview data",
          showConfirmButton: false,
          timer: 3000,
        });
        setModalData([]);
      }
    } catch (error) {
      console.error("Error fetching preview data:", error);
      Swal.fire({
        icon: "error",
        text: error?.message || "Something went wrong",
        showConfirmButton: false,
        timer: 3000,
      });
      setModalData([]);
    } finally {
      setLoading(false);
      Swal.close();
    }
  };

  // Fetch history data on mount and when tab/page changes
  useEffect(() => {
    let timeOutFunc = setTimeout(() => {
      if (selectedFileType) {
        fetchHistoryData(pagination?.currentPage || 1);
      } else {
        setTableData([]);
        setPagination({
          currentPage: 1,
          pageSize: 2,
          totalPages: 1,
          totalCount: 0,
        });
      }
    }, 300);
    return () => clearTimeout(timeOutFunc);
  }, [selectedFileType, pagination?.currentPage]);

  // Fetch preview data when file selection changes
  useEffect(() => {
    if (modalSelectedFile) {
      fetchPreviewData(modalSelectedFile, detailsPagination.currentPage);
    }
  }, [modalSelectedFile, detailsPagination.currentPage]);

  const handleDetailsPaginationChange = async (newPage) => {
    if (modalSelectedFile) {
      await fetchPreviewData(modalSelectedFile, newPage);
    }
  };

  const onViewFile = (file) => {
    setModalSelectedFile(file);
    setDetailsPagination((prev) => ({ ...prev, currentPage: 1 }));
    fetchPreviewData(file, 1);
  };

  useEffect(() => {
    if (viewFilesModal === false) {
      setSelectedFileType(null);
      setModalSelectedFile(null);
      setShowPreviewTable(false);
      setLoading(false);
      setTableData([]);
      setPagination({
        currentPage: 1,
        pageSize: 2,
        totalPages: 1,
        totalCount: 0,
      });
      setModalSearchTerm("");
      setModalData([]);
      setDetailsPagination({
        currentPage: 1,
        pageSize: 5,
        totalPages: 1,
        totalCount: 0,
      });
    }
  }, [selectedFileType]);

  const filterModalData = () => {
    if (!modalData?.length) return [];
    if (!modalSearchTerm) return modalData;

    const searchTerm = modalSearchTerm.trim();
    if (!searchTerm) return modalData;

    return modalData.filter((item) => {
      // 1. ENT_NUM exact match (case-insensitive)
      // Only search in ENT_NUM field with exact match
      if (item.ENT_NUM?.toString() === searchTerm) {
        return true;
      }

      // 2. NAME field only (partial match, case-insensitive)
      // Only look in the NAME field, not processed_name or any other name fields
      if (
        item.NAME &&
        item.NAME.toString().toLowerCase().includes(searchTerm.toLowerCase())
      ) {
        return true;
      }

      // 3. Scenario Name exact match (case-insensitive)
      if (
        item.scenario_name &&
        item.scenario_name.toString().toLowerCase() === searchTerm.toLowerCase()
      ) {
        return true;
      }

      // If none of the exact specified fields match, return false
      return false;
    });
  };

  const handleDetailsFirstPage = () => handleDetailsPaginationChange(1);
  const handleDetailsLastPage = () =>
    handleDetailsPaginationChange(detailsPagination.totalPages);
  const handleDetailsPrevPage = () =>
    handleDetailsPaginationChange(detailsPagination.currentPage - 1);
  const handleDetailsNextPage = () =>
    handleDetailsPaginationChange(detailsPagination.currentPage + 1);

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div className="d-flex justify-content-between align-items-center">
          <h5>
            <strong>View Files</strong>
          </h5>
          <Button
            onClick={() => setViewFilesModal(false)}
            className="close-button text-black"
            style={{ minWidth: "unset" }}
          >
            <MdClose />
          </Button>
        </div>

        <div className="modal-content">
          {/* File List Table */}
          <div style={{ marginBottom: 16 }}>
            <div style={{ fontWeight: 700, marginBottom: 4 }}>File Type</div>
            <FormControl fullWidth size="small">
              <Select
                displayEmpty
                className={!selectedFileType?.value && "text-secondary"}
                value={selectedFileType?.value || ""}
                onChange={(e) => {
                  const selected = File_Types.find(
                    (type) => type.value === e.target.value
                  );
                  setSelectedFileType(selected);
                }}
              >
                <MenuItem hidden value="" disabled>
                  Select File Type
                </MenuItem>
                {File_Types.map((type) => (
                  <MenuItem key={"file-type" + type.id} value={type.value}>
                    {type.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <div className="mb-4">
            <div className="table-responsive border rounded">
              <table className="table table-bordered table-striped mb-0">
                <thead className="table-dark">
                  <tr>
                    <th>#</th>
                    <th>File Name</th>
                    <th>Load Date</th>
                    <th>Load Time</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {/* {loading && !showPreviewTable && (
                    <tr>
                      <td colSpan="5" className="text-center">
                        <img src={require("../../../assets/loader.gif")} alt="Loading..." style={{ width: "50px" }} />
                      </td>
                    </tr>
                  )} */}
                  {!loading &&
                    tableData.map((file, index) => (
                      <tr key={file.id}>
                        <td>
                          {((pagination?.currentPage || 1) - 1) *
                            (pagination?.pageSize || 5) +
                            index +
                            1}
                        </td>
                        <td>{file.file_name}</td>
                        <td>{file.loadDate}</td>
                        <td>{file.loadTime}</td>
                        <td>
                          <Button
                            variant="contained"
                            size="small"
                            startIcon={<MdVisibility />}
                            onClick={() => onViewFile(file)}
                          >
                            VIEW
                          </Button>
                        </td>
                      </tr>
                    ))}
                  {!loading && tableData.length === 0 && (
                    <tr>
                      <td colSpan="5" className="text-center">
                        No files found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Main table pagination */}
            {!loading && tableData.length > 0 && (
              <div className="d-flex justify-content-end mt-3">
                <div className="pagination">
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={onFirstPage}
                    disabled={pagination?.currentPage <= 1}
                    className="me-2"
                  >
                    First
                  </Button>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={onPrevPage}
                    disabled={pagination?.currentPage <= 1}
                    className="me-2"
                  >
                    Prev
                  </Button>
                  <span className="mx-2 align-self-center">
                    Page {pagination?.currentPage || 1} of{" "}
                    {pagination?.totalPages || 1}
                  </span>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={onNextPage}
                    disabled={
                      !pagination ||
                      pagination.currentPage >= pagination.totalPages
                    }
                    className="me-2"
                  >
                    Next
                  </Button>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={onLastPage}
                    disabled={
                      !pagination ||
                      pagination.currentPage >= pagination.totalPages
                    }
                  >
                    Last
                  </Button>
                </div>
              </div>
            )}
          </div>

          {/* Preview Table - Only show after clicking VIEW */}
          {showPreviewTable && (
            <>
              {!loading && modalData.length > 0 && (
                <>
                  <div className="row mb-3">
                    <div className="col-12">
                      <h6 className="mb-3" style={{ fontWeight: 700 }}>
                        Preview Data
                      </h6>
                    </div>
                    <div className="col-12 col-lg-6">
                      <TextField
                        fullWidth
                        size="small"
                        placeholder="Search..."
                        value={modalSearchTerm || ""}
                        onChange={(e) => {
                          setModalSearchTerm(e.target.value);
                        }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <MdSearch />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </div>
                    <div className="col-12 col-lg-6">
                      <TextField
                        fullWidth
                        size="small"
                        disabled
                        labelId="file-search-label"
                        variant="outlined"
                        value={modalSelectedFile?.file_name || ""}
                      />
                    </div>
                  </div>

                  <div className="table-responsive border rounded">
                    <table className="table table-bordered table-striped mb-0">
                      <thead className="table-dark">
                        <tr>
                          {getTableHeaders().map((header) => (
                            <th key={header.key}>{header.label}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {filterModalData().map((row, index) => (
                          <tr
                            key={
                              row.ENT_NUM || row.unique_id || row.id || index
                            }
                          >
                            {getTableHeaders().map((header, colIndex) => {
                              if (header.key === "index") {
                                return (
                                  <td
                                    key={`${
                                      row.ENT_NUM ||
                                      row.unique_id ||
                                      row.id ||
                                      index
                                    }-index`}
                                  >
                                    {(detailsPagination.currentPage - 1) *
                                      detailsPagination.pageSize +
                                      index +
                                      1}
                                  </td>
                                );
                              }
                              const value =
                                row[header.key.toLowerCase()] ||
                                row[header.key] ||
                                "N/A";
                              return (
                                <td
                                  key={`${
                                    row.ENT_NUM ||
                                    row.unique_id ||
                                    row.id ||
                                    index
                                  }-${header.key}`}
                                >
                                  {value}
                                </td>
                              );
                            })}
                          </tr>
                        ))}
                        {filterModalData().length === 0 && (
                          <tr>
                            <td
                              colSpan={getTableHeaders().length}
                              className="text-center"
                            >
                              {modalSearchTerm
                                ? "No matching records found"
                                : "No data available"}
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  {filterModalData().length > 0 && (
                    <div className="d-flex justify-content-between align-items-center mt-3">
                      <div>
                        Showing{" "}
                        {(detailsPagination.currentPage - 1) *
                          detailsPagination.pageSize +
                          1}{" "}
                        to{" "}
                        {Math.min(
                          detailsPagination.currentPage *
                            detailsPagination.pageSize,
                          detailsPagination.totalCount
                        )}{" "}
                        of {detailsPagination.totalCount} entries
                      </div>
                      <div className="d-flex gap-2">
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={handleDetailsFirstPage}
                          disabled={detailsPagination.currentPage <= 1}
                          className="me-2"
                        >
                          First
                        </Button>
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={handleDetailsPrevPage}
                          disabled={detailsPagination.currentPage <= 1}
                          className="me-2"
                        >
                          Prev
                        </Button>
                        <span className="mx-2 align-self-center">
                          Page {detailsPagination.currentPage} of{" "}
                          {detailsPagination.totalPages}
                        </span>
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={handleDetailsNextPage}
                          disabled={
                            detailsPagination.currentPage >=
                            detailsPagination.totalPages
                          }
                          className="me-2"
                        >
                          Next
                        </Button>
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={handleDetailsLastPage}
                          disabled={
                            detailsPagination.currentPage >=
                            detailsPagination.totalPages
                          }
                        >
                          Last
                        </Button>
                      </div>
                    </div>
                  )}
                </>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

ViewFilesModal.propTypes = {
  setViewFilesModal: PropTypes.func.isRequired,
  tabsData: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedTab: PropTypes.number.isRequired,
  handleModalViewFile: PropTypes.func.isRequired,
  modalSelectedFile: PropTypes.shape({
    id: PropTypes.string,
    fileName: PropTypes.string,
    fileType: PropTypes.string,
    loadDate: PropTypes.string,
    loadTime: PropTypes.string,
    bankCode: PropTypes.string,
  }),
  modalSearchTerm: PropTypes.string,
  handleModalSearch: PropTypes.func.isRequired,
  pagination: PropTypes.shape({
    currentPage: PropTypes.number,
    pageSize: PropTypes.number,
    totalPages: PropTypes.number,
    totalCount: PropTypes.number,
  }),
  onFirstPage: PropTypes.func.isRequired,
  onLastPage: PropTypes.func.isRequired,
  onPrevPage: PropTypes.func.isRequired,
  onNextPage: PropTypes.func.isRequired,
};

ViewFilesModal.defaultProps = {
  modalSelectedFile: null,
  modalSearchTerm: "",
  pagination: {
    currentPage: 1,
    pageSize: 5,
    totalPages: 1,
    totalCount: 0,
  },
};

export default ViewFilesModal;
